import _ from 'lodash';
import { Toast, ToastOptions } from '@hb/coffee';

let loadings: symbol[] = [];

export class Loading {
  static startOne(loadingSymbol: symbol, options?: ToastOptions): symbol {
    const defaultOptions: ToastOptions = {
      duration: 0,
      forbidClick: true,
      message: '',
    };
    loadings.push(loadingSymbol);
    Toast.loading({ ...defaultOptions, ...options });

    return loadingSymbol;
  }

  static finishOne(loadingSymbol?: symbol): symbol | undefined {
    if (!loadingSymbol) return undefined;
    loadings = _.remove(loadings, loadingSymbol);
    if (loadings.length === 0) {
      Toast.clear();
    }

    return loadingSymbol;
  }

  static get isLoading(): boolean {
    return !!loadings.length;
  }

  static clearAll(): void {
    loadings = [];
    Toast.clear();
  }

  static trigger(
    start?: boolean,
    loadingOptions?: ToastOptions,
  ): symbol | undefined {
    // eslint-disable-next-line symbol-description
    return start ? Loading.startOne(Symbol(), loadingOptions) : undefined;
  }
}
